/**
 * Game constants and configuration
 */

import type { FactionId } from '@/types';

/**
 * Starting positions for each faction on the map
 */
export const FACTION_POSITIONS: Record<FactionId, { x: number; z: number }> = {
  lin: { x: 70, z: 0 },        // 林国 - East (forest nation)
  yan: { x: 60, z: 70 },       // 炎国 - Northeast (fire nation)
  han: { x: 0, z: -80 },       // 寒国 - South (ice nation)
  shang: { x: -30, z: 60 },    // 商国 - Northwest (merchant nation)
  xuan: { x: -90, z: -10 },    // 玄国 - West (mystic nation)
  tie: { x: -60, z: -60 },     // 铁国 - Southwest (iron nation)
  yun: { x: 50, z: -60 },      // 云国 - Southeast (cloud nation)
  neutral: { x: 0, z: 0 },     // Not placed
};

/**
 * Building display names (Chinese)
 */
export const BUILDING_NAMES: Record<string, string> = {
  capital: '主城',
  barracks: '兵营',
  archery: '箭营',
  spearcamp: '枪营',
  stable: '马厩',
  smithy: '铁匠铺',
  temple: '道观',
  tower: '箭塔',
  mine: '矿场',
  farm: '农场',
  market: '市场',
  wall: '城墙',
};

/**
 * All playable faction IDs (excluding neutral)
 */
export const ALL_FACTIONS: FactionId[] = ['yan', 'han', 'lin', 'shang', 'xuan', 'tie', 'yun'];
